import { nativeEnum, number, object } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Award_Points_Rounding_Strategy } from '@occc/graphql';

export const AwardPointsPerSchema = object({
  points: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  rounding: nativeEnum(Award_Points_Rounding_Strategy, { required_error: IS_REQUIRED }),
});
